import { render, staticRenderFns } from "./upload_self.vue?vue&type=template&id=352f122c&scoped=true&"
import script from "./upload_self.vue?vue&type=script&lang=js&"
export * from "./upload_self.vue?vue&type=script&lang=js&"
import style0 from "./upload_self.vue?vue&type=style&index=0&id=352f122c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352f122c",
  null
  
)

component.options.__file = "upload_self.vue"
export default component.exports